import { render, staticRenderFns } from "./CyberboardTypingKit.vue?vue&type=template&id=e6bece9a&scoped=true"
import script from "./CyberboardTypingKit.vue?vue&type=script&lang=ts"
export * from "./CyberboardTypingKit.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardTypingKit.vue?vue&type=style&index=0&id=e6bece9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bece9a",
  null
  
)

export default component.exports